import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

// Renders text with **bold** segments
function Rich({ text }) {
  const parts = text.split("**");
  return (
    <>
      {parts.map((p, i) => (i % 2 === 1 ? <strong key={i} className="font-bold text-sk-cream">{p}</strong> : <span key={i}>{p}</span>))}
    </>
  );
}

function Block({ block }) {
  if (block.p) return <p className="text-sk-muted leading-relaxed"><Rich text={block.p} /></p>;
  if (block.ul) {
    return (
      <ul className="space-y-2">
        {block.ul.map((item, i) => (
          <li key={i} className="flex gap-3 text-sk-muted leading-relaxed">
            <span className="mt-2 h-1.5 w-1.5 rounded-full bg-sk-brand shrink-0" />
            <span><Rich text={item} /></span>
          </li>
        ))}
      </ul>
    );
  }
  if (block.sub) {
    return (
      <div className="space-y-2.5">
        <p className="font-bold text-sk-cream">{block.sub}</p>
        <ul className="space-y-2">
          {block.ul_items.map((item, i) => (
            <li key={i} className="flex gap-3 text-sk-muted leading-relaxed">
              <span className="mt-2 h-1.5 w-1.5 rounded-full bg-sk-brand/60 shrink-0" />
              <span><Rich text={item} /></span>
            </li>
          ))}
        </ul>
      </div>
    );
  }
  return null;
}

export default function LegalLayout({ title, lastUpdated, sections }) {
  return (
    <div className="min-h-screen bg-sk-bg text-sk-cream">
      <header className="sticky top-0 z-30 bg-sk-bg/85 backdrop-blur-md border-b border-sk-line">
        <div className="max-w-3xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
          <Link to="/" data-testid="legal-logo-link"><img src="/logo.png" alt="Studio Kreator" className="h-8 w-auto" /></Link>
          <Link to="/" data-testid="legal-back-link" className="flex items-center gap-1.5 text-sm font-semibold text-sk-muted hover:text-sk-cream transition-colors">
            <ArrowLeft className="h-4 w-4" /> Kembali
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-5 sm:px-8 py-12 sm:py-16">
        <span className="inline-flex items-center gap-2 rounded-full border border-sk-line bg-sk-surface px-3 py-1.5 text-[11px] font-semibold uppercase tracking-wider text-sk-muted">
          <span className="h-1.5 w-1.5 rounded-full bg-sk-brand" /> Dokumen resmi
        </span>
        <h1 className="mt-5 font-extrabold text-4xl sm:text-5xl tracking-tight text-sk-cream">{title}</h1>
        <p className="mt-3 text-sm text-sk-muted">Terakhir diperbarui: {lastUpdated}</p>

        <div className="mt-10 rounded-2xl border border-sk-line bg-sk-surface p-6 sm:p-10 shadow-sm divide-y divide-sk-line">
          {sections.map((s, i) => (
            <section key={i} data-testid={`legal-section-${i}`} className="scroll-mt-20 py-7 first:pt-0 last:pb-0">
              <h2 className="font-bold text-lg sm:text-xl tracking-tight text-sk-brand">
                {s.n ? <span className="tabular-nums mr-2">{s.n}.</span> : null}{s.title}
              </h2>
              <div className="mt-4 space-y-4">
                {s.blocks.map((b, j) => <Block key={j} block={b} />)}
              </div>
            </section>
          ))}
        </div>

        <div className="mt-14 border-t border-sk-line pt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <Link to="/kebijakan-privasi" className="text-sm font-semibold text-sk-muted hover:text-sk-brand transition-colors">Kebijakan Privasi</Link>
          <Link to="/syarat-layanan" className="text-sm font-semibold text-sk-muted hover:text-sk-brand transition-colors">Syarat Layanan</Link>
          <a href="mailto:halo@studiokreator.id" className="text-sm font-semibold text-sk-muted hover:text-sk-brand transition-colors">halo@studiokreator.id</a>
        </div>
      </main>
    </div>
  );
}
